import React, { Component } from 'react';
import { Col, Form, message, Modal, Row, Switch } from 'antd';
import {
  queryCustomDepartmentDistributionList,
  queryDepartmentList,
  querySaveCustomDepartmentDistribution,
} from '@api/crm/crm';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      distributions: [],
      data: [],
    };
  }

  componentDidMount() {
    this.loadDepartments.then(() => {
      const { uuid } = this.props;
      this.loadData(uuid);
    });
  }

  loadDepartments = new Promise((resolve, reject) => {
    queryDepartmentList().then(res => {
      if (res.statusCode === 200) {
        this.setState({ departments: res.data });
        resolve();
      } else {
        message.error(res.message);
        reject();
      }
    });
  });

  loadData = uuid => {
    queryCustomDepartmentDistributionList(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({ distributions: res.data }, this.handlerData);
      }
    });
  };

  submit = params => {
    const { uuid } = this.props;
    if (uuid) {
      params.customUuid = uuid;
    }

    querySaveCustomDepartmentDistribution(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  onChange = uuid => {
    return () => {
      const { data } = this.state;
      const result = data.map(item => {
        if (item.uuid === uuid) {
          item.isOpen = true;
        }
        return item;
      });
      this.setState({ data: result }, () => this.submit({ departmentUuid: uuid }));
    };
  };

  handlerData = () => {
    const { departments, distributions } = this.state;
    const result = departments.map(department => {
      const checks = distributions
        ? distributions.filter(distribution => {
            return distribution.departmentUuid === department.uuid;
          })
        : [];

      department.isOpen = checks.length > 0;
      return department;
    });
    this.setState({ data: result });
  };

  renderForm = () => {
    const { data } = this.state;

    return data.map((item, index) => {
      return (
        <Row style={{ marginTop: 15 }} key={item.uuid}>
          <Col span={12}>
            <span style={{ width: 200 }}>{item.organizationName}</span>
            <Switch
              style={{ float: 'right' }}
              className={`switch-${index}`}
              checked={item.isOpen}
              disabled={item.isOpen}
              onChange={this.onChange(item.uuid)}
            />
          </Col>
        </Row>
      );
    });
  };

  render() {
    const { handleModalVisible } = this.props;

    return (
      <Modal title="下放" visible onCancel={() => handleModalVisible(false)} footer={false}>
        {this.renderForm()}
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/ModalDepartment.js